
import { X } from "lucide-react";

interface DomainTagProps {
  domain: string;
  onRemove: (domain: string) => void;
}

export const DomainTag = ({ domain, onRemove }: DomainTagProps) => {
  return (
    <div className="bg-muted px-3 py-1 rounded-full flex items-center gap-1 text-sm">
      <span>{domain}</span>
      <button 
        type="button" 
        onClick={() => onRemove(domain)}
        className="text-muted-foreground hover:text-foreground"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
};
